import { normalize, schema } from 'normalizr'

export const SECONDS_IN_MS = seconds => seconds * 1000
export const MEGABYTES_IN_BYTES = megabyte => megabyte * 1024 * 1024

const service = new schema.Entity(
  'services',
  {},
  { idAttribute: 'name', processStrategy: entity => entity.serviceId }
)

const accountSchema = new schema.Entity(
  'accounts',
  { services: [service] },
  { idAttribute: 'accountId' }
)

export const accountsSchema = new schema.Array(accountSchema)
export const normalizeAccounts = accounts => normalize(accounts, accountsSchema)
export const normalizeSingleAccount = account => normalize(account, accountSchema)
